<template>
  <v-container fluid v-if="user">
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare.png')"
          class="mx-auto"
          contain
          max-height="100px">
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-center">
          CONȚINUTUL MATERIALELOR PUBLICATE PE ACEST SITE NU REPREZINTĂ ÎN MOD OBLIGATORIU POZIȚIA OFICIALĂ A UNIUNII EUROPENE SAU A GUVERNULUI ROMÂNIEI.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title style="justify-content: center" v-if="user">
            Bine ati venit, {{ user.firstName }} {{ user.lastName }}
          </v-card-title>

          <v-card-text>
            <v-data-iterator
              :items="users"
              :options.sync="options"
              :server-items-length="totalItems"
              :loading="loading">

              <template v-slot:header>
                <v-toolbar flat color="white">
                  <v-btn rounded small @click="refresh" color="accent">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-divider vertical class="mx-4" inset></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    label="Cautare"
                    class="mx-4"
                    clearable
                    hint="Cautare dupa: nume, prenume sau email"></v-text-field>
                  <!-- <v-spacer></v-spacer>
                  <v-divider vertical class="mx-4" inset></v-divider> -->
                </v-toolbar>
              </template>

              <template v-slot:default="props">
                <v-row>
                  <v-col
                    v-for="user in props.items"
                    :key="user._id"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="4"
                    xl="3">
                    <v-card>
                      <v-card-title :class="{'primary--text': user._id === filesUserId }" class="subheading font-weight-bold">
                        {{ user.firstName }} {{ user.lastName }} (
                          <v-icon :color="user.submitted ? 'success' : 'error'">
                            {{ user.submitted ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          {{ user.submitted ? 'dosar depus' : 'dosar in lucru' }}
                        )
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-content>Nume:</v-list-item-content>
                            <v-list-item-content class="align-end" style="width: 100%; overflow-x: auto">{{ user.details && user.details.lastName ? user.details.lastName : user.lastName }}</v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>Prenume:</v-list-item-content>
                            <v-list-item-content class="align-end" style="width: 100%; overflow-x: auto">{{ user.details && user.details.firstName ? user.details.firstName : user.firstName }}</v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>Email:</v-list-item-content>
                            <v-list-item-content class="align-end" style="width: 100%; overflow-x: auto">{{ user.details && user.details.email ? user.details.email : user.email }}</v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>Telefon:</v-list-item-content>
                            <v-list-item-content class="align-end" style="width: 100%; overflow-x: auto">{{ user.details && user.details.phone ? user.details.phone : 'N/A' }}</v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>Inscris:</v-list-item-content>
                            <v-list-item-content class="align-end" style="width: 100%; overflow-x: auto">{{ new Date(user.createdAt).toLocaleString('ro-RO') }}</v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>Arhiva fisiere:</v-list-item-content>
                            <v-list-item-content class="align-end">
                              <v-btn icon @click="downloadArchive(user._id, user.lastName + user.firstName)">
                                <v-icon>
                                  mdi-download
                                </v-icon>
                              </v-btn>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn v-if="user.submitted" text @click="unblockForm(user)">Deblocheaza Dosar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :class="{ 'primary--text': user._id === filesUserId }" text @click="setActiveUser(user)">Afiseaza fisiere</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>

            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="basil"
              grow>
              <v-tab>
                Documentele aplicantului
              </v-tab>
              <v-tab>
                Evaluarile mele
              </v-tab>
              <v-tab>
                Contestatii
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <UsersApplications />
              </v-tab-item>
              <v-tab-item>
                <ReviewerUploads />
              </v-tab-item>
              <v-tab-item>
                <ReviewerAppeals />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/parteneri.png')"
          class="mx-auto"
          contain
          max-height="60px">
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SERVER_URL from '@/config'

import { createWriteStream } from 'streamsaver'
import slug from 'slug'

import _debounce from 'lodash.debounce'

import UsersApplications from '@/components/UsersApplications.vue'
import ReviewerUploads from '@/components/ReviewerUploads.vue'
import ReviewerAppeals from '@/components/ReviewerAppeals.vue'

export default {
  name: 'AccountEvaluatorComponent',

  components: { UsersApplications, ReviewerUploads, ReviewerAppeals },

  data: () => ({
    SERVER_URL: SERVER_URL,
    tab: null
  }),

  watch: {
    tab (value) {
      this.$store.dispatch('setFilesTab', value)
    }
  },

  computed: {
    user () {
      return this.$store.getters.user
    },
    token () {
      return this.$store.getters.token
    },
    users () {
      return this.$store.getters.usersItems
    },
    options: {
      get () {
        return this.$store.getters.usersOptions
      },
      set (value) {
        this.$store.dispatch('setUsersOptions', value)
      }
    },
    totalItems () {
      return this.$store.getters.usersTotal
    },
    loading () {
      return this.$store.getters.usersLoading
    },
    search: {
      get () {
        return this.$store.getters.usersSearch
      },
      set: _debounce(function (value) {
        this.$store.dispatch('setUsersSearch', value)
      }, 500)
    },
    filesUserId () {
      return this.$store.getters.filesUserId
    }
  },

  methods: {
    refresh () {
      this.$store.dispatch('fetchUsers')
    },

    setActiveUser (user) {
      this.$store.dispatch('setFilesUserId', user._id)
    },

    unblockForm (user) {
      this.$store.dispatch('undoDepunere', user._id)
    },

    async downloadArchive (id, name) {
      const res = await fetch(`${this.SERVER_URL}/rest-archive`, {
        method: 'post',
        headers: new Headers({
          Authorization: this.token,
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify({ id })
      })

      const fileStream = createWriteStream(`arhiva_iss_${slug(name, '_')}.zip`)

      // more optimized
      if (res.body.pipeTo) {
        return res.body.pipeTo(fileStream)
      }

      const writer = fileStream.getWriter()
      const reader = res.body.getReader()
      const pump = () => reader.read().then(({ value, done }) => done
        // close the stream so we stop writing
        ? writer.close()
        // Write one chunk, then get the next one
        : writer.write(value).then(pump)
      )

      // Start the reader
      pump().then(() =>
        console.log('Closed the stream, Done writing')
      )
    }
  },

  mounted () {
    this.$store.dispatch('setUsersApproved', true)
    this.$store.dispatch('setSelectedUserType', 'aplicant')
  },

  beforeDestory () {
    this.$store.commit('setUsers', [])
    this.$store.commit('setUsersApproved', null)
    this.$store.commit('setSelectedUserType', 'toate')
    this.$store.commit('setFilesUserId', null)
  }
}
</script>
